export default __webpack_public_path__ + "static/media/ttg-icon.af89c46f.svg";